export interface DamConfig {
  damEnabled: boolean;
  errorCode: number;
  errorMessage: string;
}

export interface User {
  success: boolean,
  message: string,
  accessToken: string,
  userId: number,
  userName: string,
  returnUrl: string,
  bId: string,
  damApiUrl: string,
  isDamEnabled: boolean,
  pId: number,  
  industryName: string,
  industryId: string,
  isCmsEnabled: boolean,
  isCmsBlogEnabled: boolean,
  profileName: string,
  cmsSiteUrl: string,
  websiteDomain: string,
  //isContentIntelEnabled: boolean,
  //isContentGenEnabled: boolean,
  isAgencyUser: boolean,
  businessName:string;
  businessAlias:string;
  profileAlias:string;
  dprBaseUrl: string;
  businessThingId: string;
  userThingId: string;
  expiryTimestamp: number;
  referrer: string;
  brandVoiceUrl: string;
  targetAudienceUrl: string;
  businessInformationUrl: string;
  error: any;
  planId: string;
  logoUrl: string;
  faviconUrl: string;
  agencyName: string;
  agencyId: string;
  expiresAt:number;
  contentGenerationId:string;
  isWorkflowEnabled: boolean;
  workflowDefinitionId: number;
  // What the user may do under the moderation workflow; resolved server-side per profile.
  moderationAccess: ModerationAccess;
  activeSessionId: string;
}

// Mirrors ContentStudio.Entities.Workflow.ModerationAccess on the backend.
export enum ModerationAccess {
  // Agency users, moderation workflow off, or no Moderator roles configured for the business.
  Full = 0,
  // Approver holding a configured Moderator role: editor only (read-only review, comment,
  // publish/update/schedule, approve). Everywhere else sends them to MPC approval management.
  Moderator = 1,
  // Everyone else while Moderator roles are configured: authors and submits for review, but
  // cannot publish, update or schedule.
  NonModerator = 2
}

export class VerifyUserRequest{
  businessId:number;
  profileAlias:string;
}

export class LoginResponse {
  access_token: string;
  refresh_token: string;
  expires_in: number;
  errorcode: number;
  errorMessage: number;
  rememberMe: boolean;
  url: string;
  token_type: string;
  cookie_prefix: string;
}

export class UserInfo {
  featureIds: string[];
  isSaasUser: boolean;
  userFirstName: string;
  userLastName: string;
  userRoleName: string;
  isTrialPeriod: boolean;
  trialEndDate: any;
  enableKnowledgeVault: boolean;
}
